import { connect } from 'react-redux';

import { startBuyAnalytics } from '../../actions/buyAnalyticsModal';
import { DescriptionBuyAnalyticsBlock } from '../../components/BuyAnalyticsBlocks';
import { IDescriptionBuyAnalyticsBlockProps } from '../../components/BuyAnalyticsBlocks/components/DescriptionBuyAnalyticsBlock/types';
import { IBuyAnalyticsBlockProps } from '../../components/BuyAnalyticsBlocks/types';
import { selectbuyAnalyticsFullPropertyName, selectBuyAnalyticsReportPrice } from '../../selectors/buyAnalyticsModal';
import { IState } from '../../store';

/* istanbul ignore next */
export const DescriptionBuyAnalyticsBlockContainer = connect<
  IDescriptionBuyAnalyticsBlockProps,
  IBuyAnalyticsBlockProps,
  {},
  IState
>(
  state => {
    return {
      buildingName: selectbuyAnalyticsFullPropertyName(state),
      reportPrice: selectBuyAnalyticsReportPrice(state),
    };
  },
  {
    onBuyClick: startBuyAnalytics,
  },
)(DescriptionBuyAnalyticsBlock);
